"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HtmlPlugin = void 0;
const tsyringe_1 = require("tsyringe");
const PluginBase_1 = require("../../core/pluginSystem/PluginBase");
const HtmlFormComponent_1 = require("./HtmlFormComponent");
const HtmlPanel_1 = require("./HtmlPanel");
let HtmlPlugin = class HtmlPlugin extends PluginBase_1.PluginBase {
    get useHomePanelWidget() {
        return true;
    }
    get friendlyPluginName() { return "HTML Plugin"; }
    get pluginName() { return "HTMLPlugin"; }
    get description() { return "Allows custom HTML to be added to a music page."; }
    get useNewSongForm() { return true; }
    get useMusicDetailsPanels() { return true; }
    getNewSongFormComponent() {
        return new HtmlFormComponent_1.HtmlFormComponent(this);
    }
    getMusicDetailPanels() {
        return [new HtmlPanel_1.HtmlPanel(this)];
    }
    getEditSongFormComponent() {
        return new HtmlFormComponent_1.HtmlFormComponent(this);
    }
    getHomePanelWidget() {
        return new HtmlPanel_1.HtmlPanel(this);
    }
};
HtmlPlugin = __decorate([
    tsyringe_1.injectable()
], HtmlPlugin);
exports.HtmlPlugin = HtmlPlugin;
//# sourceMappingURL=HtmlPlugin.js.map